import { Component, Input, OnInit } from '@angular/core';

export enum OTPError {
  invalid_otp = 'invalid_otp',
  expired_otp = 'expired_otp',
  user_disabled = 'user_disabled',
  wait_for_attempt = 'wait_for_attempt',
}

@Component({
  selector: 'bn-otp-error-msg',
  templateUrl: './banesco-otp-error-msg.component.html',
})
export class BnOtpErrorMsgComponent implements OnInit {
  @Input() errorCode!: OTPError;
  @Input() errorMesssageComplement?: string;
  @Input() displayError = true;
  errorMessage = '';

  ngOnInit(): void {
    console.log(this.errorMesssageComplement);
    this.errorMessage = this.getErrorMessage(this.errorCode);
    if (this.errorMesssageComplement) {
      this.errorMessage += `. ${this.errorMesssageComplement}`;
    }
  }

  getErrorMessage(errorCode: OTPError): string {
    switch (errorCode) {
      case 'wait_for_attempt':
        return $localize`:@@otp-validation-wait-for-attempt:A new verification code is not allowed at this moment`;
      case 'invalid_otp':
        return $localize`:@@otp-validation-invalid-otp:Invalid OTP`;
      case 'expired_otp':
        return $localize`:@@otp-validation-expired-otp:Expired code`;
      case 'user_disabled':
        return $localize`:@@otp-validation-user-disabled:User is disabled`;
      default:
        return $localize`:@@otp-validation-default-error:Something went wrong`;
    }
  }
}
